import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseURL from '../utils/baseURL';
import useAxiosAuth from '../hooks/useAxiosAuth';
import { getAdminById } from './adminSlice';
import { logout } from './authSlice';

// ✅ Get All Specialties
export const getallSpeciality = createAsyncThunk(
    'doctor/getallSpeciality',
    async (doctorId, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.get(`${baseURL}/doctors/getall/specialtyMod/${doctorId}`);
            const jsonResponse = response.data;
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Update Specialty in master
export const editSpeciality = createAsyncThunk(
    'doctor/editSpeciality',
    async ({ doctorId, specialtyId, name, color, description }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.put(`${baseURL}/doctors/specialty/${specialtyId}`, { 
                name, 
                color,
                ...(description && { description })
            });
            const jsonResponse = response.data;
            dispatch(getallSpeciality(doctorId));
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Delete Specialty in master
export const removeSpeciality = createAsyncThunk(
    'doctor/removeSpeciality',
    async ({ doctorId, specialtyId }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.delete(`${baseURL}/doctors/remove/specialtyMod/${specialtyId}`);
            const jsonResponse = response.data;
            dispatch(getallSpeciality(doctorId));
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Add Specialty
export const addspecialitys = createAsyncThunk(
    'doctor/addspecialitys',
    async (objdata, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.post(`${baseURL}/doctors/addspecialty`, {
                name: objdata.name,
                color: objdata.color,
                doctorId: objdata.doctorId,
                ...(objdata.description && { description: objdata.description })
            });
            const jsonResponse = response.data;
            dispatch(getallSpeciality(objdata.doctorId));
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Set Specialty Thunk
export const specialitySetdoctor = createAsyncThunk(
    'doctor/specialitySetdoctor',
    async ({ doctorId, specialties }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        // const doctorId = localStorage.getItem('ID');
        try {
            const response = await axiosInstance.post(`${baseURL}/doctors/appointmentspeciality/${doctorId}`,
                {specialties},
            );
            const jsonResponse = response.data;
            dispatch(getDoctorById(doctorId));
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Update Specialty
export const updateSpeciality = createAsyncThunk(
    'doctor/updateSpeciality',
    async ({ specialtyId, name, color }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        const doctorId = localStorage.getItem('ID');
        try {
            const response = await axiosInstance.put(`${baseURL}/doctors/appointmentspeciality/${doctorId}/${specialtyId}`, {
                name,
                color,
                specialtyId,
            });
            const jsonResponse = response.data;
            dispatch(getDoctorById(doctorId));
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Delete Specialty
export const deleteSpeciality = createAsyncThunk(
    'doctor/deleteSpeciality',
    async ({ doctorId, specialtyId }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        // const doctorId = localStorage.getItem('ID');
        try {
            const response = await axiosInstance.delete(`${baseURL}/doctors/appointmentspeciality/${doctorId}/${specialtyId}`);
            const jsonResponse = response.data;
            dispatch(getDoctorById(doctorId));
            return jsonResponse;
        } catch (error) {
            console.log('error', error);
            return rejectWithValue({ error });
        }
    }
);

// ✅ Add Appointment Specialty
export const createAppointmentSpeciality = createAsyncThunk(
    'doctor/createAppointmentSpeciality',
    async (data, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        // const doctorId = localStorage.getItem('ID');
        try {
            const response = await axiosInstance.post(`${baseURL}/doctors/appointmenttypespecality/${data.doctorId}/${data.specialid}`, data.val);
            const jsonResponse = response.data;
            dispatch(getDoctorById(data.doctorId));
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Update Appointment Specialty
export const updateAppointmentSpeciality = createAsyncThunk(
    'doctor/updateAppointmentSpeciality',
    async (data, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        // const doctorId = localStorage.getItem('ID');
        try {
            const response = await axiosInstance.put(
                `${baseURL}/doctors/appointmenttypespecality/${data.doctorId}/${data.specialid}/${data.val?.typeId}`,
                data.val
            );
            const jsonResponse = response.data;
            dispatch(getDoctorById(data.doctorId));
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Delete Appointment Specialty
export const deleteAppointmentSpeciality = createAsyncThunk(
    'doctor/deleteAppointmentSpeciality',
    async (data, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        // const doctorId = localStorage.getItem('ID');
        try {
            const response = await axiosInstance.delete(
                `${baseURL}/doctors/appointmenttypespecality/${data.doctorId}/${data.specialid}/${data?.typeId}`
            );
            const jsonResponse = response.data;
            dispatch(getDoctorById(data.doctorId));
            return jsonResponse;
        } catch (error) {
            console.log('error', error);
            return rejectWithValue({ error });
        }
    }
);

// ✅ Check Appointment By Type ID
export const checkAppointmentByTypeId = createAsyncThunk(
    'doctor/checkAppointmentByTypeId',
    async ({ doctorId, specialtyId, typeId }, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.get(
                `${baseURL}/doctors/appointmenttypespecality/${doctorId}/${specialtyId}/${typeId}`
            );
            const jsonResponse = response.data;
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Check Appointment By Visio
export const checkAppointmentByVisio = createAsyncThunk(
    'doctor/checkAppointmentByVisio',
    async ({ doctorId, specialtyId, typeId }, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.get(
                `${baseURL}/doctors/appointmenttypespecality/visio/${doctorId}/${specialtyId}/${typeId}`
            );
            const jsonResponse = response.data;
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Check License Number Existence
export const checkLicenseExists = createAsyncThunk(
    'doctor/checkLicenseExists',
    async ({ licenseNumber, axiosInstance }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`${baseURL}/doctors/lisenceExist`, {
                licenseNumber: licenseNumber.trim()
            });
            // Response structure: { exists: true/false, message: { en: "...", fr: "..." } }
            return response.data;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Update Doctor Status
export const updateDoctorStatus = createAsyncThunk(
    'doctor/updateDoctorStatus',
    async ({ doctorId, status }, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.post(`${baseURL}/doctors/update-status`, {
                doctorId,
                status
            });
            const jsonResponse = response.data;
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Doctor Registration
export const doctorRegistration = createAsyncThunk(
    'doctor/doctorRegistration',
    async ({ name, surname, email, password, confirmPassword, countryId, timeZone, profession, gender, dob, invitationCode, emailVerified }, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const payload = {
                name,
                surname,
                email,
                password,
                confirmPassword,
                countryId,
                timeZone,
                ...(profession ? { profession } : {}),
                gender,
                dob,
                emailVerified,
            };
            
            // Build URL with invitationCode as query parameter if it exists
            let url = `${baseURL}/doctors/register`;
            if (invitationCode) {
                url += `?invitationCode=${encodeURIComponent(invitationCode)}`;
            }
            
            const response = await axiosInstance.post(url, payload);
            const jsonResponse = response.data;
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Add Doctor
export const addDoctor = createAsyncThunk(
    'doctor/addDoctor',
    async ({ formData, nav }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.post(`${baseURL}/doctors`, formData);
            const jsonResponse = response.data;
            dispatch(getAllDoctors({ page: 1, limit: 5 }));
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Update Password
export const UpdatePassword = createAsyncThunk(
    'doctor/updatePassword',
    async ({ docId, body, addpatient }, { rejectWithValue }) => {
        console.log('docId', docId, body);
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.put(`${baseURL}/patients/resetpassword/${docId}`, body);
            const jsonResponse = response.data;
            console.log('jsonResponse', jsonResponse);
            return jsonResponse;
        } catch (error) {
            console.log('error', error);
            return rejectWithValue({ error });
        }
    }
);

// ✅ Update Doctor Profile Image
export const doctorProfileUpdate = createAsyncThunk(
    'doctor/profileupdateitem',
    async (objdata, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.post(
                `${baseURL}/doctors/profileupload/${objdata.docid}`,
                objdata.formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            const jsonResponse = response.data;
            await dispatch(getDoctorById(objdata.docid)).unwrap();
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Update Doctor Info
export const UpdateDoctor = createAsyncThunk(
    'doctor/updateDoctor',
    async ({ docid, editedData, passkey }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.post(`${baseURL}/doctors/profileupdate/${docid}`, editedData);
            const jsonResponse = response.data;
            await dispatch(getDoctorById(docid)).unwrap();
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Get All Doctors
export const getAllDoctors = createAsyncThunk(
    'doctor/getAllDoctors',
    async ({ page = 1, limit = 5, search = '', availability, gender = '', countryId = '', timeZone = '', status = '' } = {}, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const params = new URLSearchParams({ page, limit });
            if (search) params.append('search', search);
            if (availability !== undefined) params.append('availability', availability);
            if (gender) params.append('gender', gender);
            if (countryId) params.append('countryId', countryId);
            if (timeZone) params.append('timeZone', timeZone);
            if (status) params.append('status', status);

            const response = await axiosInstance.get(`${baseURL}/doctors?${params.toString()}`);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch doctors';
            return rejectWithValue({ error: errorMessage });
        }
    }
);

// ✅ Get Doctor Name List for Selection
export const getDoctorNameList = createAsyncThunk(
    'doctor/getDoctorNameList',
    async (search = '', { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const url = search
                ? `${baseURL}/doctors/select/doctorsList?search=${encodeURIComponent(search)}`
                : `${baseURL}/doctors/select/doctorsList`;

            const response = await axiosInstance.get(url);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch doctors list';
            return rejectWithValue({ error: errorMessage });
        }
    }
);

// ✅ Get Doctor Name List by Patient
export const getDoctorNameListByPatient = createAsyncThunk(
    'doctor/getDoctorNameListByPatient',
    async (patientId, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const params = new URLSearchParams();
            if (patientId) {
                params.append('patientId', patientId);
            }
            const url = `${baseURL}/doctors/select/doctorsListByPatient?${params.toString()}`;
            const response = await axiosInstance.get(url);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch doctors list by patient';
            return rejectWithValue({ error: errorMessage });
        }
    }
);

// ✅ Get Doctor by ID
export const getDoctorById = createAsyncThunk(
    'doctor/getDoctorById',
    async (id, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        const userRole = localStorage.getItem('Role');
        const lang = localStorage.getItem('i18nextLng') || 'en';
        try {
            const response = await axiosInstance.get(`${baseURL}/doctors/${id}`);
            if (userRole === 'doctor' && response.data.status === 'inactive') {
                dispatch(logout({ lang }));
                window.location.href = '/login';
                return rejectWithValue({ message: 'Doctor account is inactive', status: 403 });
            }
            return response.data;
        } catch (error) {
            // Extract only serializable error properties
            const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch doctor details';
            const errorStatus = error?.response?.status || null;
            return rejectWithValue({ 
                message: errorMessage,
                status: errorStatus,
                code: error?.code || null
            });
        }
    }
);

// ✅ Get Doctor Profile Image
export const getDoctorProfileImage = createAsyncThunk(
    'doctor/getDoctorProfileImage',
    async (id, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.get(`${baseURL}/doctors/profiledownload/${id}`, { responseType: 'blob' });
            console.log('response', response);
            const blob = response.data;
            console.log('response.data', response.data);
            const imageUrl = URL.createObjectURL(blob);
            console.log(imageUrl);
            return imageUrl;
        } catch (error) {
            console.log('error', error);
            if (error.message === 'Request failed with status code 404') {
                return rejectWithValue({ error: "Request failed with status code 404" });
            } else {
                return rejectWithValue({ error });
            }
        }
    }
);

// ✅ Delete Doctor
export const deleteDoctor = createAsyncThunk(
    'doctor/deleteDoctor',
    async (docID, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.delete(`${baseURL}/doctors/${docID}`);
            const jsonResponse = response.data;
            dispatch(getAllDoctors({ page: 1, limit: 5 }));
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Create Address
export const createAddress = createAsyncThunk(
    'doctor/createAddress',
    async ({ doctorId, addressData }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.post(`${baseURL}/doctors/profileaddressupdate/${doctorId}`, addressData);
            const jsonResponse = response.data;
            await dispatch(getDoctorById(doctorId)).unwrap();
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Update Address
export const updateAddress = createAsyncThunk(
    'doctor/updateAddress',
    async (objdata, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.post(`${baseURL}/doctors/profileaddressupdate/${objdata.doctorId}`, objdata.addressData);
            const jsonResponse = response.data;
            await dispatch(getDoctorById(objdata.doctorId)).unwrap();
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Delete Address
export const deleteAddress = createAsyncThunk(
    'doctor/deleteAddress',
    async ({ addressId, docId }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.delete(`${baseURL}/doctors/addressdelete/${addressId}/${docId}`);
            const jsonResponse = response.data;
            await dispatch(getDoctorById(docId)).unwrap();
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Update Availability
export const updateAvailability = createAsyncThunk(
    'doctor/updateAvailability',
    async ({ doctorId, availability, oldAvailability }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        // const doctorId = localStorage.getItem('ID');
        try {
            const response = await axiosInstance.patch(`${baseURL}/doctors/availabilityupdate/${doctorId}`, { updateData: availability });
            const jsonResponse = response.data;
            await dispatch(getDoctorById(doctorId)).unwrap();
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Update Leave Dates
export const updateLeave = createAsyncThunk(
    'doctor/updateLeave',
    async ({ doctorId, leaveData }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        // const doctorId = localStorage.getItem('ID');
        try {
            const response = await axiosInstance.patch(`${baseURL}/doctors/updateleavedate/${doctorId}`, leaveData);
            const jsonResponse = response.data;
            await dispatch(getDoctorById(doctorId)).unwrap();
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Update Leave Range (multi-day)
export const updateLeaveRange = createAsyncThunk(
    'doctor/updateLeaveRange',
    async ({ doctorId, leaveData }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.patch(`${baseURL}/doctors/updateleavedate-range/${doctorId}`, leaveData);
            const jsonResponse = response.data;
            await dispatch(getDoctorById(doctorId)).unwrap();
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Cancel Appointments and Book Leave Range
export const cancelAndBookLeaveRange = createAsyncThunk(
    'doctor/cancelAndBookLeaveRange',
    async ({ doctorId, leaveData }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.patch(`${baseURL}/doctors/cancel-and-book-leave-range/${doctorId}`, leaveData);
            const jsonResponse = response.data;
            await dispatch(getDoctorById(doctorId)).unwrap();
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Delete Leave
export const deleteLeave = createAsyncThunk(
    'doctor/deleteLeave',
    async ({ leaveId, doctorId }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.delete(`${baseURL}/doctors/deleteleavedate/${doctorId}/${leaveId}`);
            const jsonResponse = response.data;
            await dispatch(getDoctorById(doctorId)).unwrap();
            return jsonResponse;
        } catch (error) {
            console.log('error', error);
            return rejectWithValue({ error });
        }
    }
);

// Get leave groups for a doctor
export const getLeaveGroups = createAsyncThunk(
    'doctor/getLeaveGroups',
    async ({ doctorId, year }, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const params = year ? { year } : {};
            const response = await axiosInstance.get(`${baseURL}/doctors/${doctorId}/leaveGroups`, { params });
            return response.data;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// Delete an entire leave group
export const deleteLeaveGroup = createAsyncThunk(
    'doctor/deleteLeaveGroup',
    async ({ doctorId, groupId, year }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.delete(`${baseURL}/doctors/leaveGroup/${doctorId}/${groupId}`);
            await dispatch(getDoctorById(doctorId)).unwrap();
            if (year) dispatch(getAllLeave({ doctorId, year }));
            dispatch(getLeaveGroups({ doctorId, year }));
            return response.data;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// The doctor Files/Keywords thunks were dead copies of the tenant app's —
// no SA screen ever dispatched them — deleted with the feature (2026-09-02).

// Get All Leave Dates
export const getAllLeave = createAsyncThunk(
    'doctor/getAllLeave',
    async ({ doctorId, year }, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.get(`${baseURL}/doctors/${doctorId}/leaveDates/${year}`);
            const jsonResponse = response.data;
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Check Booked Appointments for Leave Dates
export const bookedAppointmentCheck = createAsyncThunk(
    'doctor/bookedAppointmentCheck',
    async ({ doctorId, startDate, endDate, appointmentStatus, page, limit }, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.get(`${baseURL}/appointment/filter/appoint`, {
                params: { doctorId, startDate, endDate, appointmentStatus, page, limit }
            });
            const jsonResponse = response.data;
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Get Doctor Settings
export const getDoctorSettings = createAsyncThunk(
    'doctor/getDoctorSettings',
    async (doctorId, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.get(`${baseURL}/doctors/get/docSetting/${doctorId}`);
            const jsonResponse = response.data;
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
);

// ✅ Update Doctor Settings
// export const updateDoctorSettings = createAsyncThunk(
//     'doctor/updateDoctorSettings',
//     async ({ doctorId, status, duration, businessHour, leaveRestriction, breakRestriction, earlyOpenRestriction }, { rejectWithValue }) => {
//         const axiosInstance = useAxiosAuth();
//         try {
//             const response = await axiosInstance.put(`${baseURL}/doctors/update/docSettin`, {
//                 doctorId,
//                 status,
//                 duration,
//                 businessHour,
//                 leaveRestriction,
//                 breakRestriction,
//                 earlyOpenRestriction
//             });
//             const jsonResponse = response.data;
//             return jsonResponse;
//         } catch (error) {
//             return rejectWithValue({ error });
//         }
//     }
// );

// ✅ Update Doctor Settings - FIXED
export const updateDoctorSettings = createAsyncThunk(
    'doctor/updateDoctorSettings',
    async (data, { rejectWithValue }) => {           // ← Don't destructure here
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.put(`${baseURL}/doctors/update/docSettin`, {
                doctorId: data.doctorId,
                // Send all possible fields
                status: data.status,
                duration: data.duration,
                businessHour: data.businessHour,
                leaveRestriction: data.leaveRestriction,
                breakRestriction: data.breakRestriction,
                earlyOpenRestriction: data.earlyOpenRestriction,
                pastDateRestriction: data.pastDateRestriction,
                pastDateWindowDays: data.pastDateWindowDays,
                prescriptionSections: data.prescriptionSections,   // ← Added
            });

            return response.data;
        } catch (error) {
            console.error("Update settings error:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// ✅ Remove Doctor Admin Profile Image
export const removeDoctorAdminProfileImage = createAsyncThunk(
    'doctor/removeDoctorAdminProfileImage',
    async ({ role, doctorId }, { rejectWithValue, dispatch }) => {
        const axiosInstance = useAxiosAuth();
        // const role = localStorage.getItem('Role');
        try {
            const response = await axiosInstance.delete(`${baseURL}/doctors/profileremove/${doctorId}`);
            const jsonResponse = response.data;
            // Refresh doctor data to reflect removed image
            if (role === 'admin') {
                await dispatch(getAdminById(doctorId)).unwrap();
            } else if (role === 'doctor') {
                await dispatch(getDoctorById(doctorId)).unwrap();
            }
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error: error.response?.data || error.message });
        }
    }
);

export const getAllChatPatient = createAsyncThunk(
    'doctor/viewPatientList',
    async ({ doctorId }, { rejectWithValue }) => {
        console.log("slice", doctorId);
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.get(`${baseURL}/patients/select/patientsListChat/${doctorId}`);
            const jsonResponse = response.data;
            return jsonResponse;
        } catch (error) {
            return rejectWithValue({ error });
        }
    }
)

// Get My Patients (for doctor to see their patients)
export const getMyPatients = createAsyncThunk(
    'doctor/getMyPatients',
    async (
        {
            doctorId,
            page = 1,
            limit = 10,
            search = '',
            gender = '',
            countryId = ''
        },
        { rejectWithValue }
    ) => {
        const axiosInstance = useAxiosAuth();
        try {
            const params = new URLSearchParams({ page, limit });
            if (search) params.append('search', search);
            if (gender) params.append('gender', gender);
            if (countryId) params.append('countryId', countryId);
            const response = await axiosInstance.get(`${baseURL}/doctors/${doctorId}/patients?${params.toString()}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// Get Doctors Library (for library page - all doctors)
export const getDoctorsLibrary = createAsyncThunk(
    'doctor/getDoctorsLibrary',
    async (
        {
            page = 1,
            limit = 10,
            search = '',
            gender = '',
            countryId = '',
            patientId = '',
            specialty = '',
            categoryId = ''
        } = {},
        { rejectWithValue }
    ) => {
        const axiosInstance = useAxiosAuth();
        try {
            const params = new URLSearchParams({ page, limit });
            if (search) params.append('search', search);
            if (gender) params.append('gender', gender);
            if (countryId) params.append('countryId', countryId);
            if (patientId) params.append('patientId', patientId);
            if (specialty) params.append('specialty', specialty);
            if (categoryId) params.append('categoryId', categoryId);
            const response = await axiosInstance.get(`${baseURL}/doctors/all?${params.toString()}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// The doctorSlice remains unchanged since it doesn't handle toast notifications
const doctorSlice = createSlice({
    name: 'doctor',
    initialState: {
        doctors: [],
        doctorNameList: [], // List of doctors for selection dropdown
        doctorNameListByPatient: [], // List of doctors for selection dropdown by patient
        selectedDoctor: null,
        profileImage: null,
        doctorData: null,
        specialties: [],
        leaves: [],
        leaveGroups: [],
        leaveGroupsLoading: false,
        doctorSettings: null,
        bookedAppointments: [],
        removeloading: false,
        loading: false,
        loadingList: false,
        leaveLoading: false,
        bookedAppointmentsLoading: false,
        checkAppointmentLoading: false,
        checkAppointmentVisioLoading: false,
        patientListChat: [],
        error: null,
        success: false,
        licenseCheckLoading: false,
        licenseCheckResult: null, // { exists: true/false, message: {...} }
        licenseCheckError: null,
        // Pagination metadata
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0,
        // My Patients (for doctor)
        myPatients: [],
        myPatientsLoading: false,
        myPatientsTotal: 0,
        myPatientsPage: 1,
        myPatientsLimit: 10,
        myPatientsTotalPages: 0,
        // Doctors Library
        doctorsLibrary: [],
        doctorsLibraryLoading: false,
        doctorsLibraryTotal: 0,
        doctorsLibraryPage: 1,
        doctorsLibraryLimit: 10,
        doctorsLibraryTotalPages: 0,
    },
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        clearSelectedDoctor: (state) => {
            state.selectedDoctor = null;
        },
        updateChatList: (state, action) => {
            const updatedChat = action.payload;

            // Handle both chatListUpdate structure (with nested patient) and direct patient structure
            const patientId = updatedChat.patientId || updatedChat.patient?.patientId;
            const patientData = updatedChat.patient || updatedChat;
            
            const index = state.patientListChat.findIndex(
                p => p.patientId === patientId
            );

            const incomingMsg = updatedChat.lastMessage;
            const incomingId = incomingMsg?._id;

            // Use unreadForDoctor for doctor's view (or fallback to unread)
            const unreadCount = updatedChat.unreadForDoctor !== undefined 
                ? updatedChat.unreadForDoctor 
                : updatedChat.unread || 0;

            // Case 1: Patient exists
            if (index !== -1) {
                const patient = state.patientListChat[index];

                const existingMsg = patient.lastMessage;
                const existingId = existingMsg?._id;

                // ✨ If no NEW message, still update unread count and other fields
                if (existingId === incomingId) {
                    state.patientListChat[index] = {
                        ...patient,
                        ...patientData,
                        unviewedCount: unreadCount,
                        unread: unreadCount,
                        unreadForDoctor: unreadCount,
                    };
                    return;
                }

                // Replace the message and update patient data
                state.patientListChat[index] = {
                    ...patient,
                    ...patientData,
                    lastMessage: incomingMsg,
                    unviewedCount: unreadCount,
                    unread: unreadCount,
                    unreadForDoctor: unreadCount,
                };
            } else {
                // Case 2: New chat
                state.patientListChat.push({
                    ...patientData,
                    patientId: patientId,
                    lastMessage: incomingMsg,
                    unviewedCount: unreadCount,
                    unread: unreadCount,
                    unreadForDoctor: unreadCount,
                });
            }

            // ✨ After update, sort by valid timestamp
            state.patientListChat.sort((a, b) => {
                const dateA = a.lastMessage?.createdAt
                    ? new Date(a.lastMessage.createdAt)
                    : 0;

                const dateB = b.lastMessage?.createdAt
                    ? new Date(b.lastMessage.createdAt)
                    : 0;

                return dateB - dateA;
            });
        },
    },
    extraReducers: (builder) => {
        builder
            // Get All Specialties
            .addCase(getallSpeciality.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getallSpeciality.fulfilled, (state, action) => {
                state.loading = false;
                state.specialties = action?.payload?.specialty;
                state.success = true;
            })
            .addCase(getallSpeciality.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to fetch specialties';
            })
            // Edit Specialty
            .addCase(editSpeciality.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(editSpeciality.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                const updatedSpecialty = action.payload;
                const index = state.specialties.findIndex(s => s._id === updatedSpecialty._id);
                if (index !== -1) {
                    state.specialties[index] = { ...state.specialties[index], ...updatedSpecialty };
                }
            })
            .addCase(editSpeciality.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to edit specialty';
            })
            // Remove Specialty
            .addCase(removeSpeciality.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(removeSpeciality.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                const specialtyId = action.meta.arg.specialtyId;
                state.specialties = state.specialties.filter(s => s._id !== specialtyId);
            })
            .addCase(removeSpeciality.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to remove specialty';
            })
            // Add Specialty
            .addCase(addspecialitys.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addspecialitys.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(addspecialitys.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to add specialty';
            })
            // Set Specialty
            .addCase(specialitySetdoctor.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(specialitySetdoctor.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(specialitySetdoctor.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to set specialty';
            })
            // Update Specialty
            .addCase(updateSpeciality.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateSpeciality.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(updateSpeciality.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to update specialty';
            })
            // Delete Specialty
            .addCase(deleteSpeciality.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteSpeciality.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(deleteSpeciality.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to delete specialty';
            })
            // Add Appointment Specialty
            .addCase(createAppointmentSpeciality.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createAppointmentSpeciality.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(createAppointmentSpeciality.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to add appointment specialty';
            })
            // Update Appointment Specialty
            .addCase(updateAppointmentSpeciality.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAppointmentSpeciality.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(updateAppointmentSpeciality.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to update appointment specialty';
            })
            // Delete Appointment Specialty
            .addCase(deleteAppointmentSpeciality.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteAppointmentSpeciality.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(deleteAppointmentSpeciality.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to delete appointment specialty';
            })
            // Doctor Registration
            .addCase(doctorRegistration.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(doctorRegistration.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(doctorRegistration.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to register doctor';
            })
            // Add Doctor
            .addCase(addDoctor.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addDoctor.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(addDoctor.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to add doctor';
            })
            // Update Password
            .addCase(UpdatePassword.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(UpdatePassword.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(UpdatePassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to update password';
            })
            // Get All Doctors
            .addCase(getAllDoctors.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllDoctors.fulfilled, (state, action) => {
                state.loading = false;
                state.doctors = action.payload.doctors || [];
                state.total = action.payload.total || 0;
                state.page = action.payload.page || 1;
                state.limit = action.payload.limit || 5;
                state.totalPages = action.payload.totalPages || 0;
            })
            .addCase(getAllDoctors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to fetch doctors';
            })
            // Get Doctor Name List
            .addCase(getDoctorNameList.pending, (state) => {
                state.loadingList = true;
                state.error = null;
            })
            .addCase(getDoctorNameList.fulfilled, (state, action) => {
                state.loadingList = false;
                state.doctorNameList = action.payload || [];
            })
            .addCase(getDoctorNameList.rejected, (state, action) => {
                state.loadingList = false;
                state.error = action.payload?.error || 'Failed to fetch doctors list';
            })
            // Get Doctor Name List by Patient
            .addCase(getDoctorNameListByPatient.pending, (state) => {
                state.loadingList = true;
                state.error = null;
            })
            .addCase(getDoctorNameListByPatient.fulfilled, (state, action) => {
                state.loadingList = false;
                state.doctorNameListByPatient = action.payload || [];
            })
            .addCase(getDoctorNameListByPatient.rejected, (state, action) => {
                state.loadingList = false;
                state.error = action.payload?.error || 'Failed to fetch doctors list by patient';
            })
            // Get Doctor by ID
            .addCase(getDoctorById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getDoctorById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedDoctor = action.payload;
            })
            .addCase(getDoctorById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || action.payload || 'Failed to fetch doctor details';
            })
            // Update Doctor
            .addCase(UpdateDoctor.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(UpdateDoctor.fulfilled, (state, action) => {
                state.loading = false;
                if (state.selectedDoctor && state.selectedDoctor._id === action.payload?._id) {
                    state.selectedDoctor = { ...state.selectedDoctor, ...action.payload };
                }
            })
            .addCase(UpdateDoctor.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to update doctor';
            })
            // Get Doctor Profile Image
            .addCase(getDoctorProfileImage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getDoctorProfileImage.fulfilled, (state, action) => {
                state.loading = false;
                state.profileImage = action.payload;
                console.log('action.payload', action.payload);
            })
            .addCase(getDoctorProfileImage.rejected, (state, action) => {
                state.loading = false;
                state.profileImage = null;
                state.error = action.payload?.error;
            })
            // Update Profile Image
            .addCase(doctorProfileUpdate.pending, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(doctorProfileUpdate.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.doctorData = { ...state.doctorData, ...action.payload };
            })
            .addCase(doctorProfileUpdate.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Profile update failed';
            })
            // Delete Doctor
            .addCase(deleteDoctor.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(deleteDoctor.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(deleteDoctor.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to delete doctor';
                state.success = false;
            })
            .addCase(createAddress.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createAddress.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                if (state.selectedDoctor && state.selectedDoctor._id === action.payload?._id) {
                    state.selectedDoctor = { ...state.selectedDoctor, ...action.payload };
                }
            })
            .addCase(createAddress.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to update address';
            })
            .addCase(updateAddress.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAddress.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                if (state.selectedDoctor && state.selectedDoctor._id === action.payload?._id) {
                    state.selectedDoctor = { ...state.selectedDoctor, ...action.payload };
                }
            })
            .addCase(updateAddress.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to update address';
            })
            .addCase(deleteAddress.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteAddress.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(deleteAddress.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to delete address';
            })
            .addCase(updateAvailability.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAvailability.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                if (state.selectedDoctor && state.selectedDoctor._id === action.payload?._id) {
                    state.selectedDoctor = { ...state.selectedDoctor, ...action.payload };
                }
            })
            .addCase(updateAvailability.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to update availability';
            })
            .addCase(updateLeave.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateLeave.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                if (state.selectedDoctor && state.selectedDoctor._id === action.payload?._id) {
                    state.selectedDoctor = { ...state.selectedDoctor, ...action.payload };
                }
            })
            .addCase(updateLeave.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to update leave dates';
            })
            .addCase(deleteLeave.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteLeave.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(deleteLeave.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to delete leave';
            })
            // Get All Leave Dates
            .addCase(getAllLeave.pending, (state) => {
                state.leaveLoading = true;
                state.error = null;
            })
            .addCase(getAllLeave.fulfilled, (state, action) => {
                state.leaveLoading = false;
                state.leaves = action.payload;
                state.success = true;
            })
            .addCase(getAllLeave.rejected, (state, action) => {
                state.leaveLoading = false;
                state.error = action.payload?.error || 'Failed to fetch leave dates';
            })
            // Get Leave Groups
            .addCase(getLeaveGroups.pending, (state) => {
                state.leaveGroupsLoading = true;
            })
            .addCase(getLeaveGroups.fulfilled, (state, action) => {
                state.leaveGroupsLoading = false;
                state.leaveGroups = action.payload?.data || [];
            })
            .addCase(getLeaveGroups.rejected, (state) => {
                state.leaveGroupsLoading = false;
            })
            // Check Booked Appointments for Leave Dates
            .addCase(bookedAppointmentCheck.pending, (state) => {
                state.bookedAppointmentsLoading = true;
                state.error = null;
            })
            .addCase(bookedAppointmentCheck.fulfilled, (state, action) => {
                state.bookedAppointmentsLoading = false;
                state.bookedAppointments = action.payload.appointments || [];
                state.success = true;
            })
            .addCase(bookedAppointmentCheck.rejected, (state, action) => {
                state.bookedAppointmentsLoading = false;
                state.bookedAppointments = [];
                state.error = action.payload?.error || 'Failed to check booked appointments';
            })
            // Get Doctor Settings
            .addCase(getDoctorSettings.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getDoctorSettings.fulfilled, (state, action) => {
                state.loading = false;
                state.doctorSettings = action.payload.data;
                state.success = true;
            })
            .addCase(getDoctorSettings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to fetch doctor settings';
            })
            // Update Doctor Settings
            .addCase(updateDoctorSettings.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateDoctorSettings.fulfilled, (state, action) => {
                state.loading = false;
                state.doctorSettings = action.payload.data;
                state.success = true;
            })
            .addCase(updateDoctorSettings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to update doctor settings';
            })
            // Remove Doctor Admin Profile Image
            .addCase(removeDoctorAdminProfileImage.pending, (state) => {
                state.removeloading = true;
                state.error = null;
            })
            .addCase(removeDoctorAdminProfileImage.fulfilled, (state) => {
                state.removeloading = false;
                state.success = true;
                state.profileImage = null; // Clear cached image URL
            })
            .addCase(removeDoctorAdminProfileImage.rejected, (state, action) => {
                state.removeloading = false;
                state.error = action.payload?.error || 'Failed to remove profile image';
            })
            // Get Patient List for Chat
            .addCase(getAllChatPatient.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllChatPatient.fulfilled, (state, action) => {
                state.loading = false;
                state.patientListChat = action.payload.data;
                state.success = true;
            })
            .addCase(getAllChatPatient.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to fetch patient list for chat';
            })
            // Get My Patients
            .addCase(getMyPatients.pending, (state) => {
                state.myPatientsLoading = true;
                state.error = null;
            })
            .addCase(getMyPatients.fulfilled, (state, action) => {
                state.myPatientsLoading = false;
                state.myPatients = action.payload.patients || [];
                state.myPatientsTotal = action.payload.total || 0;
                state.myPatientsPage = action.payload.page || 1;
                state.myPatientsLimit = action.payload.limit || 10;
                state.myPatientsTotalPages = action.payload.totalPages || 0;
            })
            .addCase(getMyPatients.rejected, (state, action) => {
                state.myPatientsLoading = false;
                state.error = action.payload || 'Failed to fetch my patients';
            })
            // Get Doctors Library
            .addCase(getDoctorsLibrary.pending, (state) => {
                state.doctorsLibraryLoading = true;
                state.error = null;
            })
            .addCase(getDoctorsLibrary.fulfilled, (state, action) => {
                state.doctorsLibraryLoading = false;
                state.doctorsLibrary = action.payload.doctors || [];
                state.doctorsLibraryTotal = action.payload.total || 0;
                state.doctorsLibraryPage = action.payload.page || 1;
                state.doctorsLibraryLimit = action.payload.limit || 10;
                state.doctorsLibraryTotalPages = action.payload.totalPages || 0;
            })
            .addCase(getDoctorsLibrary.rejected, (state, action) => {
                state.doctorsLibraryLoading = false;
                state.error = action.payload || 'Failed to fetch doctors library';
            })
            // Check Appointment By Type ID
            .addCase(checkAppointmentByTypeId.pending, (state) => {
                state.checkAppointmentLoading = true;
                state.error = null;
            })
            .addCase(checkAppointmentByTypeId.fulfilled, (state, action) => {
                state.checkAppointmentLoading = false;
                state.success = true;
            })
            .addCase(checkAppointmentByTypeId.rejected, (state, action) => {
                state.checkAppointmentLoading = false;
                state.error = action.payload?.error || 'Failed to check appointment';
            })
            // Check Appointment By Visio
            .addCase(checkAppointmentByVisio.pending, (state) => {
                state.checkAppointmentVisioLoading = true;
                state.error = null;
            })
            .addCase(checkAppointmentByVisio.fulfilled, (state, action) => {
                state.checkAppointmentVisioLoading = false;
                state.success = true;
            })
            .addCase(checkAppointmentByVisio.rejected, (state, action) => {
                state.checkAppointmentVisioLoading = false;
                state.error = action.payload?.error || 'Failed to check appointment visio';
            })
            // Check License Existence
            .addCase(checkLicenseExists.pending, (state) => {
                state.licenseCheckLoading = true;
                state.licenseCheckError = null;
                state.licenseCheckResult = null;
            })
            .addCase(checkLicenseExists.fulfilled, (state, action) => {
                state.licenseCheckLoading = false;
                state.licenseCheckResult = action.payload;
                state.licenseCheckError = null;
            })
            .addCase(checkLicenseExists.rejected, (state, action) => {
                state.licenseCheckLoading = false;
                state.licenseCheckError = action.payload?.error || 'Failed to check license';
                state.licenseCheckResult = null;
            })
            // Update Doctor Status
            .addCase(updateDoctorStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateDoctorStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(updateDoctorStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || 'Failed to update doctor status';
            })
    },
});

export const { clearError, clearSelectedDoctor, updateChatList } = doctorSlice.actions;
export default doctorSlice.reducer;